import * as React from 'react';
import { useSelector } from 'react-redux';

import { FlatsError } from '../../components/FlatsError';
import { OffersBlock } from '../../components/OffersBlock';
import { OffersHeader } from '../../components/OffersHeader';
import { getIsUpcomingSale, getNewbuildingDisplayName, getSalesStartHousesString } from '../../selectors/newbuilding';
import { getOffers, getSelectedHouseOffers } from '../../selectors/offers';

import { HousesFilterContainer } from '../HousesFilter';
import { OffersContainer } from '../Offers';
import { OffersReliableBlockContainer } from '../OffersReliableBlock/OffersReliableBlockContainer';
import { trackDeveloperFlatsLinkClick } from './tracking';
import { PriceRelevance } from '../PriceRelevance';
import { LayoutBlock } from '../../components/LayoutBlock';

export function OffersBlockContainer() {
  const { fromDeveloperPropsCountDisplay, fromDeveloperPropsCountUrl, fromAgentsPropsCountDisplay } =
    useSelector(getOffers);
  const flatsStats = useSelector(getSelectedHouseOffers);
  const newbuildingName = useSelector(getNewbuildingDisplayName);
  const salesStartHousesString = useSelector(getSalesStartHousesString);
  const isUpcomingSale = useSelector(getIsUpcomingSale);

  if (isUpcomingSale) {
    return (
      <LayoutBlock>
        <OffersBlock
          title={<OffersHeader newbuildingName={newbuildingName} />}
          offers={
            <FlatsError
              image="start"
              title="Продажи в этом ЖК скоро начнутся"
              text={
                <>
                  Оставьте заявку, и застройщик свяжется с вами,
                  <br />
                  как только у него появятся подробности
                </>
              }
            />
          }
        />
      </LayoutBlock>
    );
  }

  if (!fromAgentsPropsCountDisplay && !fromDeveloperPropsCountDisplay && !flatsStats) {
    return null;
  }

  return (
    <LayoutBlock>
      <OffersBlock
        title={
          <OffersHeader
            fromDeveloperPropsCountDisplay={fromDeveloperPropsCountDisplay}
            fromDeveloperPropsCountUrl={fromDeveloperPropsCountUrl}
            newbuildingName={newbuildingName}
            onLinkClick={trackDeveloperFlatsLinkClick}
            salesStartHousesString={salesStartHousesString}
          />
        }
        offers={
          <>
            <PriceRelevance />
            <HousesFilterContainer />
            <OffersContainer />
            <OffersReliableBlockContainer />
          </>
        }
      />
    </LayoutBlock>
  );
}
